import React, { useState } from 'react';
import classNames from 'classnames';
import useMediaQuery from '@mui/material/useMediaQuery';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';

import translate from '@localise/translate';

import { Font } from '@hooks/index';

import AboutUs from '@pages/AboutUs';
import Services from '@pages/Services';
import Contact from '@pages/ContactSimple';
import { DarkMap } from '@pages/Map';
import { TextWithIcon } from '@common/TextWithIcon/TextWithIcon';
import { ScrollUpButton } from '@layout/ScrollUpButton/ScrollUpButton';

import bgMain from '@images/bg-dark.png';
import bgMobile from '@images/bg-mobile.png';

import styles from './style.scss';

const Home = (): JSX.Element => {
  const [isBgLoaded, setIsBgLoaded] = useState(false);

  const useMobile = useMediaQuery('(max-width: 1280px)');

  const fontLoaded = Font.useFonts();

  const t = {
    title: translate('home.title'),
    description: translate('home.description'),
    descriptionActionButton: translate('home.descriptionActionButton'),
  };

  return (
    <>
      <header className={styles.header}>
        <div className={styles.homeStart} />
        <Fade in={isBgLoaded}>
          <div className={styles.bgHolder}>
            {useMobile ? (
              <img
                className={classNames(styles.bgMobile, styles.background, styles.active)}
                src={bgMobile}
                alt="background x-1"
                onLoad={() => {
                  setIsBgLoaded(true);
                }}
              />
            ) : (
              <img
                className={classNames(styles.bg, styles.background, styles.active)}
                src={bgMain}
                alt="background x-2"
                onLoad={() => {
                  setIsBgLoaded(true);
                }}
              />
            )}
            <div className={styles.overlay} />
          </div>
        </Fade>
        <div className={classNames(styles.home, styles.textHolder, fontLoaded && styles.loaded)}>
          {t.title && (
            <Typography variant="h1" className={styles.title} mb={2}>
              {t.title}
            </Typography>
          )}
          {t.description && (
            <Typography variant="h5" mt={1} mb={1} className={styles.description}>
              {t.description}
            </Typography>
          )}
          {t.descriptionActionButton && (
            <div className={styles.buttonActionWrap}>
              <ButtonBase classes={{ root: styles.buttonAction }} onClick={() => window.open(translate('home.descriptionActionLink'), '_blank')}>
                <div className={styles.buttonText}>{t.descriptionActionButton}</div>
              </ButtonBase>
            </div>
          )}
        </div>
        <Fade in={isBgLoaded}>
          <div className={styles.homeEnd}>
            <div className={styles.homeEndItems}>
              <TextWithIcon icon="email" text={translate('client.email')} />
              <TextWithIcon icon="phone" text={translate('client.phone')} />
            </div>
          </div>
        </Fade>
      </header>
      <div id="about" className={styles.grey}>
        <AboutUs />
      </div>
      <div id="services">
        <Services />
      </div>
      <div id="map">
        <DarkMap />
      </div>
      <div id="contact" className={styles.dark}>
        <Contact />
      </div>
      <ScrollUpButton />
    </>
  );
};

export default Home;
// dep
